export default __webpack_public_path__ + "img/youtube_70p.png";